import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AffichageCguRoutingModule} from './affichage-cgu-routing.module';
import {ButtonModule} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';
import {CardModule} from 'primeng/card';
import {MessageService} from 'primeng/api';
import {ToastModule} from 'primeng/toast';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import { AffichageCguComponent } from './affichage-cgu/affichage-cgu.component';

@NgModule({
  declarations: [
    AffichageCguComponent,
  ],
  imports: [
    CommonModule,
    AffichageCguRoutingModule,
    NgxExtendedPdfViewerModule,
    CardModule,
    ButtonModule,
    ToastModule,
    TranslateModule.forChild(),

  ],
  providers: [MessageService]

})


export class AffichageCguModule {
}
